// Phase 6 — `useElapsedSeconds` hook.
//
// Returns elapsed seconds since `start` (a `Date.now()` epoch). Samples
// via `setInterval` once per second — that's the granularity of the
// display, and per the brief avoids forcing React re-renders per
// animation frame.
//
// `start === null` returns 0.
//
// The cookchow app does not support pausing time — the food doesn't
// pause, so the clock doesn't either. A look-back slider on the
// cooking pane provides the "I want to see what just happened"
// affordance instead.

import { useEffect, useState } from 'react';

export function useElapsedSeconds(start: number | null): number {
  const [seconds, setSeconds] = useState<number>(() => {
    if (start === null) return 0;
    return Math.max(0, Math.floor((Date.now() - start) / 1000));
  });

  useEffect(() => {
    if (start === null) {
      setSeconds(0);
      return;
    }
    setSeconds(Math.max(0, Math.floor((Date.now() - start) / 1000)));
    const id = setInterval(() => {
      setSeconds(Math.max(0, Math.floor((Date.now() - start) / 1000)));
    }, 1000);
    return () => clearInterval(id);
  }, [start]);

  return seconds;
}
